<template>
  <div class="pa-4">
    <div>
      <div class="mb-2" style="font-weight: 600; font-size: 23px">
        {{ type != 'edit' ? 'เพิ่มข้อมูลนัดลูกค้า' : 'แก้ไขข้อมูลนัดลูกค้า' }}
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('สมาชิก') }">
        <div>สมาชิก</div>
        <multiselect
          :disabled="type == 'edit'"
          v-model="selectedCustomer"
          v-validate="'required'"
          :options="customers"
          :searchable="true"
          placeholder=""
          name="สมาชิก"
          :custom-label="getFullname"
          @select="onChangeCustomer"
          :allow-empty="false"
          selectLabel
          selectedLabel
          deselect-label
        >
          <!-- <template slot="singleLabel" slot-scope="{ option }"
            >{{ option.name_th }} {{ option.surname_th }}
          </template>
          <template slot="option" slot-scope="{ option }"
            >{{ option.name_th }} {{ option.surname_th }}
          </template> -->
        </multiselect>
        <p class="text-error" v-if="errors.has('สมาชิก')">
          {{ errors.first('สมาชิก') }}
        </p>
      </div>
      <div class="mt-2">
        <v-layout row wrap>
          <v-flex xs12>
            <div>อีเมล</div>
            <div class="form-control" :class="{ 'has-error': errors.has('อีเมล') }">
              <input
                :disabled="type == 'edit'"
                name="อีเมล"
                v-model="input.email"
                v-validate="'required|email'"
                type="text"
                readonly
              />
              <p class="text-error" v-if="errors.has('อีเมล')">
                {{ errors.first('อีเมล') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12>
            <div>เบอร์โทร</div>
            <div class="form-control" :class="{ 'has-error': errors.has('เบอร์โทร') }">
              <input
                :disabled="type == 'edit'"
                name="เบอร์โทร"
                v-model="input.phone_number"
                v-validate="'required'"
                type="number"
                readonly
              />
              <p class="text-error" v-if="errors.has('เบอร์โทร')">
                {{ errors.first('เบอร์โทร') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('โครงการ') }">
              <div>โครงการ</div>
              <multiselect
                :loading="projectloading"
                v-model="selectedProject"
                v-validate="'required'"
                :options="projects"
                :disabled="!selectedCustomer || type == 'edit'"
                :searchable="false"
                placeholder="เลือกโครงการ"
                name="โครงการ"
                :allow-empty="false"
                selectLabel
                selectedLabel
                deselect-label
                @select="onChangeProject"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  >{{ option.project_name }}
                </template>
                <template slot="option" slot-scope="{ option }"
                  >{{ option.project_name }}
                </template>
              </multiselect>
              <p class="text-error" v-if="errors.has('โครงการ')">
                {{ errors.first('โครงการ') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3" v-if="selectedProject">
            <div class="form-control" :class="{ 'has-error': errors.has('บ้านเลขที่') }">
              <div>บ้านเลขที่</div>
              <multiselect
                :loading="projectloading"
                v-model="input.unit_no"
                v-validate="'required'"
                :options="selectedProject.unit_list"
                :disabled="!selectedCustomer || !selectedProject || type == 'edit'"
                :searchable="false"
                placeholder="เลือกบ้านเลขที่"
                name="บ้านเลขที่"
                :allow-empty="false"
                selectLabel
                selectedLabel
                deselect-label
              >
              </multiselect>
              <p class="text-error" v-if="errors.has('บ้านเลขที่')">
                {{ errors.first('บ้านเลขที่') }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('service') }">
              <div>Services</div>
              <multiselect
                v-model="input.service"
                v-validate="'required'"
                :options="servicelist"
                placeholder="Service"
                name="service"
                :allow-empty="false"
                selectLabel
                selectedLabel
                deselect-label
                @select="selectService"
                group-values="service"
                group-label="category"
                :group-select="false"
              >
              </multiselect>
              <p class="text-error" v-if="errors.has('service')">
                {{ errors.first('service') }}
              </p>
            </div>
          </v-flex>
          <template v-if="input.service">
            <v-flex xs12>
              <div>วันที่นัดหมาย</div>
              <div class="form-control" :class="{ 'has-error': errors.has('appointment_date') }">
                <DatepickerCustomDialog
                  v-model="input.appointment_date"
                  :min="mindate"
                  :allowed-dates="allowedDates"
                  :key="timestamp"
                  @input="onchangeDate($event, true)"
                >
                  <template v-slot="{ computedDate }">
                    <input
                      name="appointment_date"
                      data-vv-as="วันที่นัดหมาย"
                      :value="computedDate"
                      readonly
                      placeholder="DD/MM/YYYY"
                      type="text"
                      v-validate="'required'"
                    />
                  </template>
                </DatepickerCustomDialog>
                <p class="text-error" v-if="errors.has('appointment_date')">
                  {{ errors.first('appointment_date') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12>
              <div>เวลานัดหมาย</div>
              <div
                class="form-control"
                :class="{ 'has-error': errors.has('appointment_time_from') }"
              >
                <multiselect
                  v-model="appointment_time_from"
                  name="appointment_time_from"
                  data-vv-as="เวลานัดหมาย"
                  v-validate="'required'"
                  :options="timeList"
                  :allow-empty="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                  label="text"
                  track-by="value"
                  :disabled="!input.appointment_date"
                />
                <!-- <CustomTimepicker v-model="input.appointment_time_from">
                  <input
                    name="appointment_time_from"
                    data-vv-as="เวลานัดหมาย - เริ่ม"
                    :value="input.appointment_time_from"
                    readonly
                    placeholder="00:00"
                    type="text"
                    v-validate="'required'"
                  />
                </CustomTimepicker> -->
                <p class="text-error" v-if="errors.has('appointment_time_from')">
                  {{ errors.first('appointment_time_from') }}
                </p>
              </div>
            </v-flex>
            <!-- <v-flex xs6 class="pl-2">
              <div>เวลานัดหมาย - สิ้นสุด</div>
              <div class="form-control">
                {{ currentEndTime }}
              </div>
            </v-flex> -->
          </template>

          <v-flex xs12>
            <div>point</div>
            <div class="form-control mb-4" :class="{ 'has-error': errors.has('point') }">
              {{ currentService ? currentService.points : 0 }} ({{ points }})
              <input name="point" type="hidden" v-model="input.point" v-validate="'required'" />
              <p class="text-error" v-if="errors.has('point')">
                {{ errors.first('point') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('status') }">
              <div>Status</div>
              <multiselect
                v-model="input.status"
                v-validate="'required'"
                :options="['Pending', 'Approved', 'Done', 'Cancel By Admin']"
                :searchable="false"
                placeholder="Status"
                name="status"
                :allow-empty="false"
                selectLabel
                selectedLabel
                deselect-label
              >
              </multiselect>
              <p class="text-error" v-if="errors.has('status')">
                {{ errors.first('status') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3 form-control">
            <div>Remark</div>

            <textarea
              name="remark"
              id="remark"
              style="width: 100%; height: 50px"
              :data-vv-as="$t('remark')"
              v-model="input.remark"
              :placeholder="$t('Remark')"
            ></textarea>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="text-xs-center">
      <v-btn @click="$emit('close')" color="grey" outline> {{ $t('cancel') }}</v-btn>
      <v-btn :loading="loading" @click="saveData" color="primary" depressed>
        {{ $t('Save') }}</v-btn
      >
    </div>

    <template v-if="input.history && input.history.length > 0">
      <v-divider class="mt-4" />

      <table>
        <thead>
          <tr class="grey lighten-3">
            <td>Admin</td>
            <td>Appointment date</td>
            <td>Appointment time</td>
            <td>Process</td>
            <td>Status</td>
            <td>Timestamp</td>
          </tr>
        </thead>
        <template v-for="history in input.history">
          <tr :key="history.timestamp">
            <td>{{ history.admin }}</td>
            <td>{{ history.appointment_date }}</td>
            <td>{{ history.appointment_time }}</td>
            <td>{{ history.process }}</td>
            <td>{{ history.status }}</td>
            <td>{{ history.timestamp }}</td>
          </tr>
        </template>
      </table>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: ['editdata', 'type', 'customers', 'value', 'services'],
  computed: {
    ...mapGetters(['selectedBot']),
    currentService() {
      try {
        return this.services.find((el) => {
          return this.input.service == el.service
        })
      } catch (error) {}
      return null
    },
    servicelist() {
      try {
        return this.services
          .filter((el) => {
            return el != null && el != ''
          })
          .reduce((prev, curr) => {
            var index = prev.findIndex((el) => {
              return el.category == curr.category_service
            })
            if (index != -1) {
              prev[index].service.push(curr.service)
            } else {
              prev.push({
                category: curr.category_service,
                service: [curr.service]
              })
            }
            return prev
          }, [])
      } catch (error) {}
      return []
    },
    currentEndTime() {
      if (this.currentService && this.input.appointment_time_from) {
        return moment(this.input.appointment_time_from, 'HH:mm')
          .add(this.currentService.spend_time, 'minutes')
          .format('HH:mm')
      } else {
        null
      }
    }
  },
  data() {
    return {
      loading: false,
      timeList: [],
      appointment_time_from: null,
      input: {
        custumer_name: '',
        appointment_date: '',
        appointment_time_from: '',
        appointment_time_to: '',
        phone_number: '',
        email: '',
        projects: '',
        point: 0,
        service: '',
        status: '',
        remark: ''
      },
      points: 0,
      projectloading: false,
      projects: [],
      selectedCustomer: '',
      selectedProject: '',
      mindate: moment().add('48', 'hours').format('YYYY-MM-DD'),
      availables: [],
      timestamp: moment().format('x')
    }
  },
  components: {
    Multiselect,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  async mounted() {
    if (this.type == 'edit') {
      this.input = cloneDeep(this.editdata)
      this.$set(
        this.input,
        'appointment_date',
        this.input.appointment_date
          ? moment(this.input.appointment_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD')
      )

      this.selectedCustomer = this.customers.find((el) => {
        return el.account_no == this.input.account_no
      })
      if (this.selectedCustomer) {
        await this.getProject(this.selectedCustomer.account_no)
        this.selectedProject = this.projects.find((el) => {
          return el.project_name == this.input.project_name
        })
      }

      this.onchangeDate(this.input.appointment_date)
      await this.$nextTick()
      this.appointment_time_from = this.timeList.find((el) => {
        return el.value == this.input.appointment_time_from
      })
    }
  },
  methods: {
    getFullname({ name_en, surname_en, name_th, surname_th }) {
      return `${name_en} ${surname_en} (${name_th} ${surname_th})`
    },
    onchangeDate(val, isChange = false) {
      let list = this.filterAvailableWeekday(
        moment.weekdays(true, moment(val).weekday()).toLowerCase()
      )
      this.errors.clear()

      if (isChange) this.$set(this.input, 'appointment_time_from', '')
      if (list.length > 0) {
        this.timeList = list
          .map((el) => {
            var end = moment(el.start, 'HH:mm')
              .add(parseInt(this.currentService.spend_time), 'minutes')
              .format('HH:mm')
            return {
              value: el.start,
              text: `${el.start} - ${end}`
            }
          })
          .sort((a, b) => {
            if (a.value > b.value) return 1
            else if (a.value < b.value) return -1
            else return 0
          })
      } else {
        this.timeList = []
      }
    },
    selectService(val) {
      this.input.appointment_date = null
      this.appointment_time_from = null
      this.errors.clear()

      var service = this.services.find((el) => {
        return val == el.service
      })
      if (service) {
        try {
          this.availables = JSON.parse(service.available)
        } catch (error) {
          this.availables = []
        }
      }
      this.timestamp = moment().format('x')
    },
    allowedDates(val) {
      try {
        return (
          this.filterAvailableWeekday(moment.weekdays(true, moment(val).weekday()).toLowerCase())
            .length > 0
        )
      } catch (error) {
        return false
      }
    },
    filterAvailableWeekday(val) {
      if (this.availables.length == 0) {
        var availables = []
        for (let index = 0; index < 24; index++) {
          availables.push({
            day: val,
            start: `${index.toString().padStart(2, '0')}:00`
          })
        }
        return availables
      }
      return this.availables.filter((el) => {
        return el.day.toLowerCase() == val || el.day == '' || el.day == null
      })
    },
    onChangeProject() {
      this.$set(this.input, 'unit_no', '')
    },
    async saveData() {
      if (
        this.currentService &&
        this.points - this.currentService.points < 0 &&
        this.input.status == 'Pending'
      ) {
        this.$swal.fire({ type: 'warning', title: 'คะแนนไม่เพียงพอ' })
      } else if (await this.$validator.validate()) {
        var timeto = moment(
          this.appointment_time_from ? this.appointment_time_from.value : '00:00',
          'HH:mm'
        )
          .add(this.currentService.spend_time, 'minutes')
          .format('HH:mm')

        var appointment = {
          ...this.input,
          project_name: this.selectedProject.project_name,
          custumer_name: this.selectedCustomer.name_en + ' ' + this.selectedCustomer.surname_en,
          custumer_name_en: this.selectedCustomer.name_en + ' ' + this.selectedCustomer.surname_en,
          custumer_name_th: this.selectedCustomer.name_th + ' ' + this.selectedCustomer.surname_th,
          account_no: this.selectedCustomer.account_no,
          point: this.currentService ? this.currentService.points : this.input.point,
          appointment_time_from: this.appointment_time_from ? this.appointment_time_from.value : '',
          appointment_time_to: timeto ? timeto : '',
          status: this.input.status == 'Cancel By Admin' ? 'Cancel By Admin' : this.input.status
        }
        this.loading = true
        this.$emit('saveAppointment', {
          appointment,
          oncomplete: () => {
            this.loading = false
          }
        })
      }
    },
    onChangeCustomer(item) {
      this.selectedCustomer = item
      this.$set(this.input, 'phone_number', item.mobile_1)
      this.$set(this.input, 'email', item.email_1)
      this.selectedProject = ''
      this.$set(this.input, 'unit_no', '')

      this.$forceUpdate()
      this.getProject(item.account_no)
    },
    getProject() {
      var data = {
        pageid: this.selectedBot.pageid,
        account_no: this.selectedCustomer.account_no
      }
      this.projectloading = true
      return new Promise((resolve, reject) => {
        api.getmjdcustomerprojectdashboard(data, (err, response) => {
          this.projectloading = false
          if (response.responsecode == 200) {
            this.projects = response.data2.reduce((prev, curr) => {
              var index = prev.findIndex((el) => {
                return el.project_name == curr.project_name
              })
              if (index != -1) {
                prev[index].unit_list.push(curr.unit_no)
              } else {
                prev.push({ ...curr, unit_list: [curr.unit_no] })
              }
              return prev
            }, [])

            this.points = response.total_points - parseInt(response.points_usage)
            resolve()
          } else {
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/EditAppointment.vue